export const getWarningMessage = (
  syncedPlanId: string | null,
  lastSuccessfulPlanId: string | null,
  savedBatchNumber: number,
  inputBatchNumber: number | null
): string | null => {
  const sameBatchNumber = savedBatchNumber === inputBatchNumber;
  const planIsUpToDate = syncedPlanId && lastSuccessfulPlanId === syncedPlanId;

  if (planIsUpToDate && sameBatchNumber) {
    return null;
  } else if (planIsUpToDate) {
    const batchDetails =
      savedBatchNumber === 1 ? '1 batch' : `${savedBatchNumber} batches`;
    return `Output plan with different batch count (${batchDetails}). It may require re-planning at runtime. Plan before publishing to avoid delays.`;
  } else if (lastSuccessfulPlanId) {
    return 'Outdated output plan. It may require re-planning at runtime. Plan before publishing to include latest workflow changes and avoid delays.';
  }
  return null;
};
